import React from "react";
import {
  UilTemperature,
  UilTear,
  UilWind,
  UilSun,
  UilSunset,
  UilArrowUp,
  UilArrowDown,
} from "@iconscout/react-unicons";
import { formatToLocalTime, iconUrlFromCode } from "../services/WeatherServices";

function TemperatureAndDetails({weather:{
  details,
  icon,
  temp,
  temp_min,
  temp_max,
  sunrise,
  sunset,
  speed,
  humidity,
  feels_like,
   timezone
}}) {
  return (
    <div>
      <div className="flex justify-center items-center text-xl text-cyan-300 py-6">
        <p>{details}</p>
      </div>

      <div className="flex flex-row items-center justify-between text-white py-3">
        <img
          src={iconUrlFromCode(icon)} 
          alt=""
          className="w-20"
        />
        <p className="text-5xl">{`${temp.toFixed()}°`}</p>

        <div className="flex flex-col space-y-2">
          <div className="flex items-center justify-center font-light text-sm">
            <UilTemperature size={18} className="mr-1" />
            Real fill:
            <span className="font-medium ml-1">{`${feels_like.toFixed()}°`}</span>
          </div>
          <div className="flex items-center justify-center font-light text-sm">
            <UilTear size={18} className="mr-1" />
            Humidity:
            <span className="font-medium ml-1">{`${humidity.toFixed()}%`}</span>
          </div>
          <div className="flex items-center justify-center font-light text-sm">
            <UilWind size={18} className="mr-1" />
            Wind :<span className="font-medium ml-1">{`${speed.toFixed()}km/h`}</span>
          </div>
        </div>
      </div>

    <div className="flex flex-row text-white font-light items-center justify-center text-sm space-x-2 py-3">
        <UilSun />
        <p className="font-light">Rise: <span className="font-medium ml-1">{formatToLocalTime(sunrise, timezone, "hh:mm a")}</span></p>
        <p className="font-light">|</p>

        <UilSunset />
        <p className="font-light">Set: <span className="font-medium ml-1">{formatToLocalTime(sunset, timezone, "hh:mm a")}</span></p>
        <p className="font-light">|</p>


        <UilArrowUp />
        <p className="font-light">High: <span className="font-medium ml-1">{`${temp_max.toFixed()}°`}</span></p>
        <p className="font-light">|</p>


        <UilArrowDown />
        <p className="font-light">Low: <span className="font-medium ml-1">{`${temp_min.toFixed()}°`}</span></p>
        <p className="font-light">|</p>
    </div>


    </div>
  );
}

export default TemperatureAndDetails;
